export default class Constants {
  static BasePageSegment = 'news';
  static BasePagePath = `/${Constants.BasePageSegment}`;
  static NewsDetailsPageSegment = 'details';
  static NewsDetailsPagePath = `${Constants.BasePagePath}/${Constants.NewsDetailsPageSegment}`;
}
